<template>

<com-setting :options="options" :value="value" v-on:change="onChange" v-if="options.length > 1" />

</template>

<script>

import comSetting from './Setting'

export default {

    props: ['type', 'value'],

    components: {
        'com-setting': comSetting
    },

    data: function() {

        return {
            name: {
                match: 'Match',
                min: 'Minimum',
                max: 'Maximum',
                range: 'Range',
                tolerance: 'Tolerance',
                rolling: 'Rolling',
                contains: 'Contains',
                oneof: 'One of set',
                someof: 'Some of set',
                allof: 'All of set'
            },
            text: {},
            numeric: {},
            toggle: {},
            select: {},
            set: {},
            date: {
                min: 'From',
                max: 'To',
                range: 'Between'
            }
        }

    },

    computed: {

        options: function() {

            var options = []

            this.$_.each(this.type.setting.logic, function(logic) {

                var text = this[this.type.type][logic] || this.name[logic]

                options.push({
                    value: logic,
                    text: (this.type.lang.logic) ? this.type.lang.logic[logic] : text
                })

            }.bind(this))

            return options

        }

    },

    methods: {

        onChange: function(value) {

            this.$emit('input', value)

        }
    
    }

}

</script>

<style scoped>

</style>